import { Injectable } from '@angular/core';
// import * as XLSX from 'xlsx';
// import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Injectable()
export class ExportExcelService {

  constructor() { }

  exportAsExcelFile(json: any[], excelFileName: string) {
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
  }
}
